import { API_URLS } from "../../constants";
import apiClient from "../../utils/interceptor";

export const getYardsByCompanyId = async (companyId) => {
  try {
    const response = await apiClient.get(
      `${API_URLS.YARD.GET_YARDS_BY_COMPANY_ID}/${companyId}`,
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching yards by company ID:", error);
    throw error;
  }
};

export const getShippingLinesByYards = async (yardIds) => {
  try {
    const response = await apiClient.post(
      `${API_URLS.SHIPPING_LINES.GET_SHIPPING_LINES_BY_YARDS}`,
      {
        yard_ids: yardIds,
      },
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching shipping lines:", error);
    throw error;
  }
};

export const getReportStats = async ({ yardIds, startDate, endDate }) => {
  try {
    const response = await apiClient.post(
      API_URLS.SCAN.GET_REPORT_STATS,
      {
        yard_ids: yardIds,
        start_date: startDate,
        end_date: endDate
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching report stats:", error);
    throw error;
  }
};

export const getLatestContainerLocation = async ({ containerNumber, companyId }) => {
  try {
    const response = await apiClient.post(
      API_URLS.PUBLIC_REPORT.GET_LATEST_CONTAINER_LOCATION,
      {
        container_number: containerNumber,
        company_id: companyId,
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching latest container location:", error);
    throw error;
  }
};
